import React from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";

import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import InputArea from "components/form/InputArea";

import Error from "components/form/Error";

import DrawerButton from "components/form/DrawerButton";
import useTripadvanceSubmit from "hooks/useTripadvanceSubmit";

const TripadvanceDrawer = ({ id }) => {
  const {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    errors,
    loading,
    // imageUrl,
    // setImageUrl,
  } = useTripadvanceSubmit(id);

  //console.log(interiorUrl1,"interior url 1");

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title
            register={register}
            title="Update Tripadvance"
            description="Update your employee necessary information from here"
          />
        ) : (
          <Title
            register={register}
            title="Add Tripadvance"
            description="Add your Tripadvance necessary information from here"
          />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card className="overflow-y-scroll flex-grow scrollbar-hide w-full max-h-full">
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="px-6 pt-8 flex-grow scrollbar-hide w-full max-h-full pb-40">
                <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
                  <LabelArea label="Registration No." />
                  <div className="col-span-8 sm:col-span-4">
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Registration No."
                      name="vehicle_reg_no"
                      type="text"
                      placeholder="tripadvance reg. no."
                      pattern={/^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/}
                    />
                    <Error errorName={errors.vehicle_reg_no} />
                  </div>
                </div>
                <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
                  <LabelArea label="Year of Tripadvance Manufactured" />
                  <div className="col-span-8 sm:col-span-4">
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Year of Tripadvance Manufactured"
                      name="year_of_vehicle_manufactured"
                      type="text"
                      placeholder="Year of Tripadvance Manufactured"
                      pattern={/^[0-9]{4}$/}
                      required={true}
                    />
                    <Error errorName={errors.year_of_vehicle_manufactured} />
                  </div>
                </div>
              </div>

              <DrawerButton
                isSubmitting={loading}
                id={id}
                title={id ? "Update" : "Submit"}
              />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>
    </>
  );
};

export default TripadvanceDrawer;
